import { CfgQuestionHeading } from '../app/types/catalog-types';
import styles from './configurator-q-heading.module.css';

export const ConfiguratorHeading = ({ heading } : {
    heading: CfgQuestionHeading
}) => {

    return <h2 className={styles.headingTitle}>{heading.title}</h2>

}